import { ManageRequestPath } from './features/ManageRequestsPaths';
import { ApprovalPaths } from './features/ApprovalPaths';
import { MaterialRequisitionPaths } from './features/MaterialRequisitionPaths';
import { ProcurementRequestPath } from './features/ProcurementPaths';

const MRFeatureRoutePath = {
  PROFILE: 'profile',
  PROFILE_DETAILS: 'details',
  ...ApprovalPaths,
  ...ManageRequestPath,
  ...MaterialRequisitionPaths,
  ...ProcurementRequestPath,
};

export default MRFeatureRoutePath;
